import { atom } from 'recoil'

const estate_detail_news_start_point_atom = atom<number>({
  key: '@estate/detail-news-start-point-atom',
  default: 1,
})

export default estate_detail_news_start_point_atom
